import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReporteCumplimientoService {
  private readonly apiUrl = environment.apiSiriUrl;

  constructor(private readonly http: HttpClient) { }

  getReporteCumplimientoProductor(payload: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}reporte/reporte-cumplimiento`, payload);
  }
}
